<template>
  <v-card tile>
    <v-card-title class="pa-4 mb-2">
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="px-4">
      <v-data-table
        :disable-pagination="true"
        class="ma-0 pa-0"
        v-model="internalSelection"
        :headers="headers"
        :items="items"
        show-select
        :loading="loading"
        :hide-default-footer="true"
        :single-select="singleSelect"
      >
      </v-data-table>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn
        tile
        class="button btn-cancel"
        elevation="0"
        @click="$emit('close')"
        >Cancel</v-btn
      >
      <v-btn
        tile
        class="button"
        color="primary"
        :disabled="loading"
        elevation="0"
        @click="done()"
        >Done</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
// FIXME: [CW-163] Use common editing popup for people list as well
import { mapActions } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    collectionRef: {
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    }, // firestore database collection reference
    /// Sets wether returned object `id` must be a readonly property or actually be added as a normal property to the object on return
    readOnlyId: {
      type: Boolean,
      default: true,
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      internalSelection: this.singleSelect ? [this.value] : this.value,
      items: [],
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions(['showError']),
    async loadData() {
      try {
        this.loading = true
        const snapshot = await this.collectionRef.get()
        this.items = snapshot.docs.map((doc) => {
          const data = doc.data()
          if (this.readOnlyId) {
            Object.defineProperty(data, 'id', { value: doc.id })
          } else {
            data.id = doc.id
          }

          return data
        })
      } catch (error) {
        console.error(error)
        this.showError(error)
      } finally {
        this.loading = false
      }
    },
    done() {
      this.$emit(
        'input',
        this.singleSelect ? this.internalSelection[0] : this.internalSelection
      )
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass" scoped>
.btn-cancel
  background-color: $inactive !important
</style>
